/**
 * CarrecView component.
 * @module components/View/CarrecView
 */
import { useSelector } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { UniversalLink, Image } from '@plone/volto/components';
import { BodyClass, hasBlocksData, flattenToAppURL } from '@plone/volto/helpers';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faFileLines } from '@fortawesome/free-regular-svg-icons';
import { isEmpty, map } from 'lodash';
import { getSocialNetworkIcon } from '../../helpers'


const CarrecView = (props) => {
  const { content } = props;

  const logoGroup = useSelector((state) => state.navroot.data?.custom_root?.logo_group);

  return (
    <>
      <BodyClass className='carrec-view' />
      <BodyClass className='smallHeader' />
        <Grid className='carrecView'>
          <Grid.Row columns={12}>           
            <Grid.Column mobile={12} table={4} computer={8} widescreen={8}>              
              <div className="mb-3 ">
                {content.email && (
                <>
                <h2 className="h6 mb-3"><FormattedMessage id="Email" defaultMessage="Email" /></h2>
                <div className='mb-3'>
                  <p><a href={"mailto:" + content.email} >{content.email}</a> </p>
                </div>
                </>
                )}
              </div>
              {!isEmpty(content.social_networks) && (
                <div className="mb-3 pt-3">
                  <h2 className="visually-hidden"><FormattedMessage id="Social Networks" defaultMessage="Social Networks" /></h2>
                  <div className='mb-3'>
                    <ul className="list-unstyled grupMunicipal__xxss">
                      {map(content?.social_networks?.items, (social_network, index) => (
                        <li className="grupMunicipal__xxss__item" key={index}>
                          <a className='grupMunicipal__xxss__link fs-5' href={social_network.link}>
                            <FontAwesomeIcon icon={getSocialNetworkIcon(social_network.social_network)} />
                            <span className="visually-hidden">Twitter</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {/* Volto Blocks */}
              {hasBlocksData(content) ? (
                <div className="userBlocks pt-3">
                  <RenderBlocks {...props} />
                </div>
              ) : null}

              {(content?.assets_declaration || content?.activities_declaration || content?.retribution) &&
                <ul className=' list-unstyled border-top border-bottom mt-4 py-3 d-flex flex-column gap-4 '>
                  {content?.assets_declaration && (
                    <li className="py-2">
                      <UniversalLink
                        className="relatedItem"
                        href={content.assets_declaration}>
                        <span className="relatedItem__icon" >
                          <FontAwesomeIcon icon={faFileLines} />
                        </span>
                        <span className="relatedItem__text">
                          <span className="relatedItem__title"><FormattedMessage id="Assets declaration" defaultMessage="Assets declaration" /></span>
                          <span className="visually-hidden"><FormattedMessage id="Opens in new window" defaultMessage="Opens in new window" /></span>
                        </span>
                      </UniversalLink>
                    </li>
                  )}

                  {content?.activities_declaration && (
                    <li className="py-2">
                      <UniversalLink
                        className="relatedItem"
                        href={content.activities_declaration}>
                        <span className="relatedItem__icon" >
                          <FontAwesomeIcon icon={faFileLines} />
                        </span>
                        <span className="relatedItem__text">
                          <span className="relatedItem__title"><FormattedMessage id="Declaració d'activitats" defaultMessage="Declaració d'activitats" /></span>
                          <span className="visually-hidden"><FormattedMessage id="Opens in new window" defaultMessage="Opens in new window" /></span>
                        </span>
                      </UniversalLink>
                    </li>
                  )}

                  {content?.retribution && (
                    <li className="py-2">
                      <UniversalLink
                        className="relatedItem"
                        href={content.retribution}>
                        <span className="relatedItem__icon" >
                          <FontAwesomeIcon icon={faFileLines} />
                        </span>
                        <span className="relatedItem__text">
                          <span className="relatedItem__title"><FormattedMessage id="Retribution" defaultMessage="Retribution" /></span>
                          <span className="visually-hidden"><FormattedMessage id="Opens in new window" defaultMessage="Opens in new window" /></span>
                        </span>
                      </UniversalLink>
                    </li>
                  )}
                </ul>
              }

              {content?.agenda && (
                <p className="mb-3 pt-4 d-flex justify-content-end">
                  <UniversalLink href={content.agenda} openLinkInNewTab={true} className="readMoreItem__btn ui button primary" >
                    <FormattedMessage id="Veure l'agenda institucional" defaultMessage="Veure l'agenda institucional" />
                    <FontAwesomeIcon icon={faArrowRight} className='ms-3' />
                    <span className="visually-hidden"><FormattedMessage id="Opens in new window" defaultMessage="Opens in new window" /></span>
                  </UniversalLink>
                </p>
              )}

            </Grid.Column>

             <Grid.Column mobile={12} table={4} computer={3} widescreen={3} className='ms-md-auto'>
              {content.preview_image && (
                <Image
                  className="carrecView__foto"
                  item={content}
                  imageField="preview_image"
                  alt=""
                />
              )}
              {logoGroup && (
                <Image src={flattenToAppURL(logoGroup['@id'])} alt="" className="carrecView__logo" />
              )}
            </Grid.Column>
            
          </Grid.Row>
        </Grid>
    </>
  );
};

export default CarrecView;